module.exports = __webpack_public_path__ + "img/237.1d33e53e.png";